var _require = require('./explorer-format'),
  truncateHash = _require.truncateHash,
  formatSaito = _require.formatSaito,
  displayName = _require.displayName,
  isAnonymousUsername = _require.isAnonymousUsername;
var RECIPIENT_LABELS = {
  0: 'self',
  1: 'external',
  2: 'script'
};
function formatDeltaSaito(delta) {
  if (delta == null || delta === '') {
    return '—';
  }
  try {
    var value = BigInt(delta);
    var formatted = formatSaito(value > 0n ? value : -value);
    if (value > 0n) {
      return "+".concat(formatted);
    }
    if (value < 0n) {
      return "\u2212".concat(formatted);
    }
    return formatted;
  } catch (err) {
    return String(delta);
  }
}
function formatBalanceSaito(nolan) {
  if (nolan == null) {
    return '—';
  }
  try {
    return formatSaito(BigInt(nolan));
  } catch (err) {
    return '—';
  }
}
function formatRecipientLabel(recipient) {
  var key = Number(recipient);
  return RECIPIENT_LABELS[key] || String(recipient !== null && recipient !== void 0 ? recipient : '—');
}
function deltaSignClass(delta) {
  try {
    var v = BigInt(delta !== null && delta !== void 0 ? delta : 0);
    if (v > 0n) return 'explorer-address-delta-positive';
    if (v < 0n) return 'explorer-address-delta-negative';
  } catch (err) {
    // ignore
  }
  return '';
}
function formatAddressActivityRows(app) {
  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentBalanceNolan = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var chronological = rows.slice().reverse();
  var runningBalance = null;
  if (currentBalanceNolan != null) {
    try {
      var total = BigInt(currentBalanceNolan);
      for (var i = rows.length - 1; i >= 0; i--) {
        var _rows$i$delta, _rows$i;
        total -= BigInt((_rows$i$delta = (_rows$i = rows[i]) === null || _rows$i === void 0 ? void 0 : _rows$i.delta) !== null && _rows$i$delta !== void 0 ? _rows$i$delta : 0);
      }
      runningBalance = total;
    } catch (err) {
      runningBalance = null;
    }
  }
  var formatted = [];
  for (var _i = 0; _i < chronological.length; _i++) {
    var row = chronological[_i];
    var delta = row.delta;
    if (runningBalance != null) {
      try {
        runningBalance += BigInt(delta !== null && delta !== void 0 ? delta : 0);
      } catch (err) {
        // keep previous balance
      }
    }
    formatted.push({
      blockId: row.block_id != null ? String(row.block_id) : '—',
      blockHash: row.block_hash || '',
      txHash: row.tx_hash || '',
      txHashDisplay: truncateHash(row.tx_hash || '', 8, 8),
      deltaSaito: formatDeltaSaito(delta),
      deltaClass: deltaSignClass(delta),
      recipient: formatRecipientLabel(row.recipient),
      balance: runningBalance != null ? formatBalanceSaito(runningBalance) : null,
      isLongestChain: Number(row.is_longest_chain) === 1
    });
  }
  formatted.reverse();
  return formatted;
}
function formatAddressSummary(app, publicKey) {
  var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var currentBalanceNolan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var netDelta = 0n;
  for (var i = 0; i < rows.length; i++) {
    try {
      var _rows$i$delta2, _rows$i2;
      netDelta += BigInt((_rows$i$delta2 = (_rows$i2 = rows[i]) === null || _rows$i2 === void 0 ? void 0 : _rows$i2.delta) !== null && _rows$i$delta2 !== void 0 ? _rows$i$delta2 : 0);
    } catch (err) {
      // skip malformed rows
    }
  }
  var key = String(publicKey || '').trim();
  var username = app.keychain.returnUsername(key);
  var hasUsername = !isAnonymousUsername(username, key);
  return {
    publicKeyLabel: hasUsername ? username : displayName(app, key),
    publicKeyFull: key,
    hasUsername: hasUsername,
    entryCount: rows.length,
    currentBalance: currentBalanceNolan != null ? formatBalanceSaito(currentBalanceNolan) : null,
    netDeltaSaito: formatDeltaSaito(netDelta)
  };
}
module.exports = {
  formatAddressActivityRows: formatAddressActivityRows,
  formatAddressSummary: formatAddressSummary,
  formatDeltaSaito: formatDeltaSaito,
  formatBalanceSaito: formatBalanceSaito,
  formatRecipientLabel: formatRecipientLabel,
  deltaSignClass: deltaSignClass
};